import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ESupportTicketSource } from "../../aiTickets.types";
import { TicketConversation } from "./ticketConversation.types";

interface RawReseller {
  firstname?: string;
  lastname?: string;
  image?: { url?: string } | null;
}

interface RawConversation {
  id: string;
  status: "ai" | "human" | "closed";
  aiEnabled: boolean;
  customerPhone?: string;
  customerDisplayName?: string;
  customerAvatarUrl?: string | null;
  resellerId?: string;
  reseller?: RawReseller | null;
}

const ROUTE_BY_SOURCE: Record<ESupportTicketSource, string> = {
  [ESupportTicketSource.WhatsApp]: "admin/whatsapp-bot/conversations",
  [ESupportTicketSource.InAppSupport]: "admin/in-app-support/conversations",
};

export const requestTicketConversation = async ({
  source,
  conversationId,
}: {
  source: ESupportTicketSource;
  conversationId: string;
}): Promise<TicketConversation> => {
  const raw: RawConversation = await instance.get(
    buildUrl(ROUTE_BY_SOURCE[source], conversationId),
  );

  if (source === ESupportTicketSource.WhatsApp) {
    return {
      id: raw.id,
      status: raw.status,
      aiEnabled: raw.aiEnabled,
      contactName: raw.customerDisplayName || raw.customerPhone || "WhatsApp",
      contactSub: raw.customerPhone ?? null,
      contactPhone: raw.customerPhone ?? null,
      contactAvatarUrl: raw.customerAvatarUrl ?? null,
    };
  }

  const name =
    `${raw.reseller?.firstname ?? ""} ${raw.reseller?.lastname ?? ""}`.trim();
  return {
    id: raw.id,
    status: raw.status,
    aiEnabled: raw.aiEnabled,
    contactName: name || raw.resellerId || "Customer",
    contactSub: raw.customerPhone ?? null,
    contactPhone: raw.customerPhone ?? null,
    contactAvatarUrl: raw.reseller?.image?.url ?? null,
  };
};
